<template>
  <div class="summary">
    <div v-if="contactForm && Object.keys(contactForm).length > 0" class="contact-info">
      <div class="header" @click="showContactInfo = !showContactInfo" :class="{'rotated' : showContactInfo}">
        <h3>{{ $t('contactForm.title') }}</h3>
        <svg xmlns="http://www.w3.org/2000/svg" height="1.2em" viewBox="0 0 512 512">
          <path
              d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/>
        </svg>
      </div>
      <template v-if="showContactInfo">
        <div class="even-row dense">
          <span>{{ $t('contactForm.companyName') }}</span>
          <span class="value">{{ contactForm.companyName }}</span>
        </div>
        <div v-if="contactForm.vatNumber" class="even-row dense">
          <span>{{ $t('contactForm.vatNumber') }}</span>
          <span class="value">{{ contactForm.vatNumber }}</span>
        </div>
        <div class="even-row dense">
          <span>{{ $t('basketSummary.addressFormatted') }}</span>
          <span class="value">{{ showAddressFormatted(contactForm) }}</span>
        </div>
        <div class="even-row dense">
          <span>{{ $t('basketSummary.zipcodeCity') }}</span>
          <span class="value">{{ `${contactForm.zipcode}  ${contactForm.city}` }}</span>
        </div>
        <div class="even-row dense">
          <span>{{ $t('country') }}</span>
          <span class="value">{{ contactForm.countryName }}</span>
        </div>
        <div class="even-row dense">
          <span>{{ $t('contactName') }}</span>
          <span class="value">{{ showContactFormatted(contactForm) }}</span>
        </div>
        <div class="even-row dense">
          <span>{{ $t('contactPhone') }}</span>
          <span class="value">{{ contactForm.contactPhone }}</span>
        </div>
        <div v-if="contactForm.contactCellphone" class="even-row dense">
          <span>{{ $t('contactCellphone') }}</span>
          <span class="value">{{ contactForm.contactCellphone }}</span>
        </div>
        <div class="even-row dense">
          <span>{{ $t('email') }}</span>
          <span class="value">{{ contactForm.email }}</span>
        </div>
        <div v-if="contactForm.reference" class="even-row dense">
          <span>{{ $t('contactForm.reference') }}</span>
          <span class="value">{{ contactForm.reference }}</span>
        </div>
        <div class="even-row dense">
          <span>{{ $t('contactForm.invoiceTnv') }}</span>
          <span class="value">{{
              (contactForm.sameInvoiceMail) ? contactForm.contactName : contactForm.invoiceTnv
            }}</span>
        </div>
        <div class="even-row dense">
          <span>{{ $t('contactForm.invoiceMail') }}</span>
          <span class="value">{{ (contactForm.sameInvoiceMail) ? contactForm.email : contactForm.invoiceMail }}</span>
        </div>
        <br>
      </template>
    </div>

    <div v-if="deliveryForm && Object.keys(deliveryForm).length > 0" class="contact-info">
      <div class="header" @click="showDeliveryInfo = !showDeliveryInfo" :class="{'rotated' : showDeliveryInfo}">
        <h3>{{ $t('deliveryForm.title') }}</h3>
        <svg v-if="deliveryForm.sameAsInvoice != 1" xmlns="http://www.w3.org/2000/svg" height="1.2em"
             viewBox="0 0 512 512">
          <path
              d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/>
        </svg>
      </div>
      <template v-if="deliveryForm.sameAsInvoice == 1">
        <div class="even-row dense">
          <span>{{ $t('basketSummary.sameDelivery') }}</span>
        </div>
        <br>
      </template>
      <template v-else-if="showDeliveryInfo">
        <div class="even-row dense">
          <span>{{ $t('location') }}</span>
          <span class="value">{{ deliveryForm.location }}</span>
        </div>
        <div class="even-row dense">
          <span>{{ $t('basketSummary.addressFormatted') }}</span>
          <span class="value">{{ showAddressFormatted(deliveryForm) }}</span>
        </div>
        <div class="even-row dense">
          <span>{{ $t('basketSummary.zipcodeCity') }}</span>
          <span class="value">{{ `${deliveryForm.zipcode}  ${deliveryForm.city}` }}</span>
        </div>
        <div class="even-row dense">
          <span>{{ $t('country') }}</span>
          <span class="value">{{ deliveryForm.countryName }}</span>
        </div>
        <div v-if="deliveryForm.contactName" class="even-row dense">
          <span>{{ $t('contactName') }}</span>
          <span class="value">{{ showContactFormatted(deliveryForm) }}</span>
        </div>
        <div v-if="deliveryForm.contactPhone" class="even-row dense">
          <span>{{ $t('contactPhone') }}</span>
          <span class="value">{{ deliveryForm.contactPhone }}</span>
        </div>
        <div v-if="deliveryForm.contactCellphone" class="even-row dense">
          <span>{{ $t('contactCellphone') }}</span>
          <span class="value">{{ deliveryForm.contactCellphone }}</span>
        </div>
        <br>
      </template>
    </div>

    <div v-if="pickupForm && Object.keys(pickupForm).length > 0" class="contact-info">
      <div class="header" @click="showPickupInfo = !showPickupInfo" :class="{'rotated' : showPickupInfo}">
        <h3>{{ $t('pickupForm.title') }}</h3>
        <svg v-if="pickupForm.sameAsInvoice != 1" xmlns="http://www.w3.org/2000/svg" height="1.2em"
             viewBox="0 0 512 512">
          <path
              d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/>
        </svg>
      </div>
      <template v-if="pickupForm.sameAsInvoice == 1">
        <div class="even-row dense">
          <span>{{ $t('basketSummary.sameCollection') }}</span>
        </div>
      </template>
      <template v-else-if="showPickupInfo">
        <div class="even-row dense">
          <span>{{ $t('location') }}</span>
          <span class="value">{{ pickupForm.location }}</span>
        </div>
        <div class="even-row dense">
          <span>{{ $t('basketSummary.addressFormatted') }}</span>
          <span class="value">{{ showAddressFormatted(pickupForm) }}</span>
        </div>
        <div class="even-row dense">
          <span>{{ $t('basketSummary.zipcodeCity') }}</span>
          <span class="value">{{ `${pickupForm.zipcode}  ${pickupForm.city}` }}</span>
        </div>
        <div class="even-row dense">
          <span>{{ $t('country') }}</span>
          <span class="value">{{ pickupForm.countryName }}</span>
        </div>
        <div v-if="pickupForm.contactName" class="even-row dense">
          <span>{{ $t('contactName') }}</span>
          <span class="value">{{ showContactFormatted(pickupForm) }}</span>
        </div>
        <div v-if="pickupForm.contactPhone" class="even-row dense">
          <span>{{ $t('contactPhone') }}</span>
          <span class="value">{{ pickupForm.contactPhone }}</span>
        </div>
        <div v-if="pickupForm.contactCellphone" class="even-row dense">
          <span>{{ $t('contactCellphone') }}</span>
          <span class="value">{{ pickupForm.contactCellphone }}</span>
        </div>
        <div class="even-row dense">
          <span>{{ $t('pickupForm.remarks') }}:</span>
        </div>
        <div class="even-row dense comment">
          <span style="font-weight: bold">{{ pickupForm.comment }}</span>
        </div>
      </template>
      <br>
    </div>

    <template v-if="isPickup && pickupForm?.remark">
      <div class="even-row dense">
        <h3 style="font-weight: bold">{{ $t('questionRemark') }}:</h3>
      </div>
      <div class="even-row dense comment">
        <span>{{ pickupForm.remark }}</span>
      </div>
      <br>
    </template>
    <template v-else-if="!isPickup && deliveryForm?.remark">
      <div class="even-row dense">
        <span>{{ $t('questionRemark') }}:</span>
      </div>
      <div class="even-row dense comment">
        <span>{{ deliveryForm.remark }}</span>
      </div>
      <br>
    </template>

    <div v-if="contactForm && contactForm.createAccount && type == 'Bestelling'" class="even-row dense"
         style="margin-bottom: 15px">
      <span
          style="font-weight: bold; text-decoration: underline">{{ $t('basketSummary.createAccount') }}</span>
    </div>

    <div class="order">
      <h3>{{ $t('basketSummary.yourOrder') }}</h3>

      <div v-if="customRows && Object.keys(customRows).length > 0" class="custom-rows">
        <div v-for="customRow in customRows" class="even-row product">
          <span class="column">{{ customRow.title }}</span>
          <span class="column small quantity">{{ customRow.aantal }}x</span>
          <span class="column medium value">{{ `${valuta} ${number_format(customRow.bestelprijs, 2, ',', '.')}` }}</span>
        </div>
      </div>
      <div v-for="product in products" class="product">
        {{ product.name }}
        <template v-if="product?.option_a && product?.option_b">
          <b>({{ product.option_a }}, {{ product.option_b }})</b>
        </template>
        <div class="price">
          <span style="color: var(--brown); font: var(--medium-14);">{{ product.item_excl }}</span>
          <span style="color: var(--brown); font: var(--medium-14);">x{{ product.amount }}</span>
          <b style="flex-grow: 1; text-align: end">{{ product.price_excl }}</b>
        </div>
      </div>
      <div v-if="kwantumKortingExcl" class="even-row product">
        <span>{{ $t('basket.quantityDiscount') }}</span>
        <b class="value">{{ kwantumKortingExcl }}</b>
      </div>
      <div v-if="dealerRow && dealerAmount" class="even-row product">
        <span>{{ dealerRow.title }}</span>
        <b class="value">{{ dealerAmount }}</b>
      </div>
      <div v-if="!benbOnly" class="even-row shipping">
        <span>{{ $t('basketSummary.shippingCost') }}</span>
        <span class="value" v-if="shippingCosts && shippingCosts.length > 0">{{ shippingCosts }}</span>
        <span class="value" v-else>{{ $t('free') }}</span>
      </div>
      <div v-else class="even-row shipping">
        <span style="color: var(--orange)">{{ $t('basket.benbShippingRule')}}</span>
      </div>
      <div :class="['even-row', 'subtotal']">
        <span>{{ $t('basket.subtotal') }}</span>
        <span v-if="customRows" class="value">{{ `${valuta} ${number_format(totalExcl, 2, ',', '.')}` }}</span>
        <span v-else-if="benbOnly" class="value">{{ totalExclBenb }}</span>
        <span v-else class="value">{{ totalExcl }}</span>
      </div>
      <div class="even-row btw">
        <span>{{ $t('basket.vat') }} ({{ vatPercentage }}%)</span>
        <span v-if="customRows" class="value">{{ `${valuta} ${number_format(totalVat, 2, ',', '.')}` }}</span>
        <span v-else-if="benbOnly" class="value">{{ totalVatBenb }}</span>
        <span v-else class="value">{{ totalVat }}</span>
      </div>
      <div class="even-row total">
        <span>{{ $t('basket.total') }}</span>
        <span v-if="customRows" class="value">{{ `${valuta} ${number_format(totalIncl, 2, ',', '.')}` }}</span>
        <span v-else-if="benbOnly" class="value">{{ totalInclBenb }}</span>
        <span v-else class="value">{{ totalIncl }}</span>
      </div>
    </div>
  </div>

</template>
<script>

import {number_format} from "../helpers/NumberHelper";

export default {
  props: {
    type: String,
    isPickup: Boolean,
    contactForm: Object,
    deliveryForm: Object,
    pickupForm: Object,
    products: Object,
    shippingCosts: String,
    totalExcl: String | Number,
    totalExclBenb: String | Number,
    vatPercentage: String | Number,
    totalVat: String | Number,
    totalVatBenb: String | Number,
    totalIncl: String | Number,
    totalInclBenb: String | Number,
    kwantumKortingExcl: String,
    dealerRow: Object,
    dealerAmount: String,
    customRows: Array,
    valuta: String,
    showShipping: {
      type: Boolean,
      default: false,
    },
    benbOnly: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      public: public_dir, //deze mag niet hetzelfde heten, anders pikt ie t niet in de productie build
      showContactInfo: false,
      showDeliveryInfo: false,
      showPickupInfo: false,
    };
  },
  watch: {},
  mounted() {
  },
  methods: {
    number_format,
    showAddressFormatted(form) {
      let addressFormatted = form.streetName;
      if (form.houseNumer && form.houseNumer.length > 0) {
        addressFormatted += ` ${form.houseNumber}`;
      }
      if (form.extension && form.extension.length > 0) {
        addressFormatted += ` ${form.extension}`;
      }
      if (form.reversedAddress) {
        addressFormatted = `${form.houseNumber} ${form.extension}  ${form.streetName}`;
      }

      return addressFormatted;
    },
    showContactFormatted(form) {
      let salutation = 'Dhr.';
      if (form.salutation == 'V') {
        salutation = 'Mevr.';
      }

      return `${salutation} ${form.contactName}`;
    }
  },
}
</script>

<style scoped>
.summary {
  margin-top: 40px;
  padding: 24px;
  background-color: #F7F7F7;
  border-radius: 8px;
}

.header {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}

.header svg {
  transition: transform 0.3s ease;
}

.header.rotated svg {
  transform: rotate(180deg);
}

.header h3,
.order h3 {
  margin-bottom: 1em;
}

.even-row {
  display: flex;
  flex-wrap: wrap;
  font: var(--medium-14);
  padding: 10px 0;
  word-break: break-word;
}

.column {
  flex: 0 0 50%;
  box-sizing: border-box;
}

.column.medium {
  flex: 0 0 30%;
}

.column.small {
  flex: 0 0 20%;
  text-align: right;
}

.column.small.quantity {
  padding-right: 15px;
}

.even-row span.value,
.product .value {
  text-align: right;
  font-weight: bold;
  margin-left: auto;
}

.even-row.dense {
  padding: 0;
}

.product {
  padding: 3px 0;
  font: var(--medium-14);
}

.product .price {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  white-space: nowrap
}

.even-row .quantity {
  color: var(--brown);
}

.even-row.btw {
  border-top: 1px solid #C9C9CC;
}

.even-row.shipping {
  padding-bottom: 0;
}

.even-row.subtotal,
.even-row.top-border {
  border-top: 1px solid #C9C9CC;
  margin-top: 10px;
}

.even-row.total {
  font: var(--medium-22);
  border-top: 1px solid #C9C9CC;
  padding-top: 15px;
}
</style>